import { useMutation } from 'react-query';

import { QueryResponse } from 'api/endPoints/GetReportAccessStatus';
import { QueryParams, setReportAccessStatus } from 'api/endPoints/SetReportAccessStatus';

export const useMutationSetReportAccessStatus = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>({
        mutationFn: (params) => setReportAccessStatus(params),
    });
};
